import ChipInput from 'components/ChipInput';
import { CONTAINER_NUMBERS_RE } from 'services/helpers/containers';

import * as React from 'react';

interface Props {
  onChange: (containers: string[]) => void;
  defaultContainers?: string[];
}

export const Containers: React.FC<Props> = (props) => {
  const [inputRef, setInputRef] = React.useState<HTMLDivElement | undefined>();
  const chipInputRef = React.useRef<ChipInput>(null);
  const [isActive, setIsActive] = React.useState<boolean>(false);
  const [isMaximumReached, setIsMaximumReached] = React.useState<boolean>(false);

  return (
    <div
      className={`rounded p-2 flex overflow-y-auto border max-w-full space-x-2 ${
        isActive ? 'border-blue-900' : 'border-gray-600'
      }`}
      onClick={() => inputRef?.focus()}
    >
      <ChipInput
        defaultValue={props.defaultContainers}
        ref={chipInputRef}
        inputRef={(ref: HTMLDivElement) => setInputRef(ref)}
        classes={{
          inputContainer: 'w-full flex items-center overflow-x-auto pr-8',
          inputRoot: 'min-w-36',
          input: 'p-0',
          copyButtonContainer: 'bg-blue-100',
          copyButtonIcon: 'text-gray-600',
          chip: {
            root: '',
            label: 'select-text',
          },
        }}
        InputProps={{
          'aria-label': 'add containers',
        }}
        fullWidth
        onMaximumReached={() => setIsMaximumReached(true)}
        maxNumberChips={100}
        alwaysShowPlaceholder
        placeholder="Ex: CMAU1234567"
        transformChipLabel={(label: string) => label.toUpperCase()}
        transformChipValue={(value: string) => value.replace(/-/gi, '').toUpperCase()}
        removeCharacters={['"', "'", ' ', '“', '”']}
        checkIfChipIsValid={(value: string) => {
          return CONTAINER_NUMBERS_RE.test(value);
        }}
        onChange={(_: string[], containers: string[]) => {
          props.onChange(containers);
        }}
        onDelete={() => isMaximumReached && setIsMaximumReached(false)}
        onFocus={() => setIsActive(true)}
        onBlur={() => setIsActive(false)}
      />
      {isMaximumReached && (
        <h4 className="text-red-900">You can&apos;t add more than 100 containers at once.</h4>
      )}
    </div>
  );
};
Containers.displayName = 'Containers';
